export const GET_PRIMARY_DASHBOARD = 'EPIC/DASH_GET_PRIMARY';
export const GET_PRIMARY_DASHBOARD_SUCCESS = 'EPIC/DASH_GET_PRIMARY_SUCCESS';
export const GET_PRIMARY_DASHBOARD_FAILURE = 'EPIC/DASH_GET_PRIMARY_FAILURE';
